<template>
  <div>
    <el-dialog title="" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :before-close="close">
      <h2 align="center" class="red">创建投稿</h2>
      <br />
      <el-form :model="form" ref="form" :rules="rules" label-width="60px">
        <el-form-item label="主题" prop="theme">
          <el-select v-model="form.theme" placeholder="请选择" style="width:calc(100% - 40px)" @change="changeTheme">
            <el-option v-for="(item,index) in themeOptions" :key="index" :label="item.name" :value="item.themeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="type">
          <el-select v-model="form.type" placeholder="请选择" style="width:calc(100% - 40px)" :disabled="!form.theme"
            @change="changeType">
            <el-option v-for="(item,index) in typeOptions" :key="index" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div align="center">
        <el-button type="primary" @click="creat()" :loading="loading">创建</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: ['dialogVisible', 'dialogData'],
    data() {
      return {
        loading: false,
        form: {
          theme: null,
          type: null
        },
        formData: {
          themeId: null,
          typeId: null,
          themeName: null,
          typeName: null
        },
        themeOptions: [],
        typeOptions: [],
        rules: {
          theme: [{
            required: true,
            message: "请选择主题",
            trigger: "blur"
          }],
          type: [{
            required: true,
            message: "请选择分类",
            trigger: "blur"
          }],
        },
      }
    },
    mounted() {
      // this.getOptions();
    },
    methods: {
      changeTheme(val) {
        this.themeOptions.find((item) => {
          if (item.themeId === val) {
            this.formData['themeId'] = item.themeId;
            this.formData['themeName'] = item.name;
          }
        });
        this.getTypeList();
      },
      changeType(val) {
        this.typeOptions.find((item) => {
          if (item.typeId === val) {
            this.formData['typeId'] = item.typeId;
            this.formData['typeName'] = item.name;
          }
        });
      },
      getOptions() {
        this.$axios.get("/web/process/upload/theme/list").then(res => {
          if (res.code == 0) {
            this.themeOptions = res.data;
            if (!this.empty(this.dialogData)) {
              if (!this.empty(this.dialogData.themeId)) {
                this.form.theme = this.dialogData.themeId;
              }
              if (!this.empty(this.dialogData.typeId)) {
                this.form.type = this.dialogData.typeId;
              }
              this.getTypeList();
            }
          }
        });
      },
      close() {
        this.form.theme = this.form.type = "";
        this.$emit("close");
      },
      //获取类别列表
      getTypeList() {
        let data = {
          params: {
            themeId: this.form.theme
          }
        };
        if (window.config.MOCK_STATUS) {
          data = {};
        }
        this.$axios.get("/web/process/upload/type/list", data).then(res => {
          if (res.code == 0) {
            this.typeOptions = res.data;
            if (!this.empty(this.dialogData)) {
              if (!this.empty(this.dialogData.typeName)) {
                res.data.find(val => {
                  if (val.name == this.dialogData.typeName) {
                    this.form.type = val.typeId;
                  }
                })
              }
            }
          }
        });
      },
      initFormData() {
        this.formData.themeId = this.form.theme;
        this.formData.typeId = this.form.type;
        this.themeOptions.find(val => {
          if (val.themeId == this.form.theme) {
            this.formData.themeName = val.name;
          }
        });
        this.typeOptions.find(val => {
          if (val.typeId == this.form.type) {
            this.formData.typeName = val.name;
          }
        })
      },
      //创建新投稿
      creat() {
        let self = this;
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.loading = true;
            this.initFormData();
            //sessionStorage.setItem("form", JSON.stringify(this.formData));
            let param =  this.encode({themeId:this.form.theme,typeId:this.form.type})
            this.$router.push({
              name: "Creat",
              query:param
            });
            this.$refs['form'].resetFields();
            this.$emit("close");
            this.loading = false;
          }
        });
      },
    },
    watch: {
      dialogVisible(to) {
        if (to) {
          this.getOptions();
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog.vue